export function getPaginatedRequestURL(path, options = {}) {
    var _a;
    if (options.url) {
        return options.url;
    }
    const params = new URLSearchParams();
    if (options.limit) {
        params.append('limit', String(options.limit));
    }
    if (options.offset) {
        params.append('limit', String(options.offset));
    }
    const queryString = params.toString();
    return (((_a = options.baseURL) !== null && _a !== void 0 ? _a : '') + path + (queryString ? `?${queryString}` : ''));
}
//# sourceMappingURL=getPaginatedRequestURL.js.map